module.exports = __webpack_public_path__ + "img/mapg.07a8dbba.jpg";